export const ThreeMoreBoxesPartial = function ThreeMoreBoxesPartial() {
  return (
    <div className="boxes">
      <div className="box">
        <svg width="70" height="70" xmlns="http://www.w3.org/2000/svg">
          <g
            fill="none"
            fillRule="evenodd"
            strokeLinecap="round"
            strokeLinejoin="round"
            stroke="var(--bgHotBlue__text)"
            strokeWidth="2"
          >
            <path d="M5.9 1v63h59.9" />
            <path d="M2 5.1L5.9 1 10 5.3M61.7 60.1l4.1 3.9-4.4 4.1M17.4 54.4a3.7 3.7 0 1 1-7.4 0 3.7 3.7 0 0 1 7.4 0zM33.9 38.5a3.7 3.7 0 1 1-7.4 0 3.7 3.7 0 0 1 7.4 0zM50.4 44.2a3.7 3.7 0 1 1-7.4 0 3.7 3.7 0 0 1 7.4 0zM67 16.7a3.7 3.7 0 1 1-7.5 0 3.7 3.7 0 0 1 7.4 0zM27.5 41L16.3 51.9M61.3 19.9L48.6 41M43.2 43l-9.5-3.3" />
          </g>
        </svg>
        <h3 className="box__headline">Renten endrer seg</h3>
        <p className="box__paragraph">
          Boliglånsrenten din er over tid sjelden den samme som er annonsert,
          fordi den kan justeres ved personlig forhandling.
        </p>
      </div>
      <div className="box">
        <svg width="70" height="70" xmlns="http://www.w3.org/2000/svg">
          <g
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
            stroke="var(--bgHotBlue__text)"
            strokeWidth="2"
          >
            <path d="M68.8 35.4L34.9 3 1 35.4M60 38.4v29.5H9.8V38.4M49.7 9.1V4.5h8.8v14.7" />
            <circle cx="26.8" cy="37.6" r="4.4" />
            <circle cx="43" cy="53.9" r="4.4" />
            <path d="M25.3 55.4L46 34.7" />
          </g>
        </svg>
        <h3 className="box__headline">Reell boliglånsrente</h3>
        <p className="box__paragraph">
          Med Penger.no kan du enkelt og smidig sammenligne den reelle
          boliglånsrenten i din by og din bank.
        </p>
      </div>
      <div className="box">
        <svg width="70" height="70" xmlns="http://www.w3.org/2000/svg">
          <g fill="var(--bgHotBlue__text)" fillRule="nonzero">
            <path d="M40.6 54.4H26.3V52h14.3a3 3 0 0 0 0-6H26.3v-2.4h14.3a5.3 5.3 0 0 1 0 10.7z" />
            <path d="M9.7 68L8 66.5l3.4-3.1a9.1 9.1 0 0 1 6.2-2.5h18c2 0 4.1-.5 6-1.4l24.2-12.8a3 3 0 1 0-2.8-5.4l-15.2 8-1-2 15.1-8a5.3 5.3 0 0 1 5 9.4L42.7 61.4a15 15 0 0 1-7 1.8h-18c-1.7 0-3.4.6-4.6 1.8l-3.4 3zM1.6 55.7L.1 54l7.6-7 .6-.6c.8-1.1 3.3-3.8 8.4-4.2 2.7-.2 4.6.4 6.3.9 1.2.3 2.2.6 3.3.6V46c-1.4 0-2.7-.4-4-.7-1.5-.5-3.1-1-5.4-.8-4.2.4-6 2.4-6.7 3.3l-.9 1-7.7 6.9zM26.8 19.4a9 9 0 1 1 0-18.1 9 9 0 0 1 0 18zm0-15.8a6.7 6.7 0 1 0 0 13.5 6.7 6.7 0 0 0 0-13.5zM40.5 39.7a9 9 0 1 1 0-18 9 9 0 0 1 0 18zm0-15.7a6.7 6.7 0 1 0 0 13.4 6.7 6.7 0 0 0 0-13.4zM53.4 22.8a9 9 0 1 1 0-18 9 9 0 0 1 0 18zm0-15.7a6.7 6.7 0 1 0 0 13.4 6.7 6.7 0 0 0 0-13.4z" />
          </g>
        </svg>
        <h3 className="box__headline">Spar penger på lånet</h3>
        <p className="box__paragraph">
          Gir banken din deg de samme vilkårene som andre med tilsvarende lån?
          Kan du spare penger ved å bytte bank?
        </p>
      </div>
      <style jsx>{`
        .box {
          padding: 36px 36px 54px 36px;
          margin-bottom: 32px;
          background-color: var(--bgHotBlue);
          border-radius: 1px;
          color: var(--bgHotBlue__text);
        }

        .box__headline {
          margin-bottom: 9px;
          font-size: 24px;
          font-weight: 700;
        }

        .box__paragraph {
          margin: 0;
          font-size: 22px;
          font-weight: 500;
          line-height: 1.5;
        }

        @media screen and (min-width: 750px) {
          .boxes {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            grid-column-gap: 18px;
          }
        }

        @media screen and (min-width: 1000px) {
          .boxes {
            grid-column-gap: 72px;
          }
        }
      `}</style>
    </div>
  );
};
